export default __webpack_public_path__ + "pause-button.svg";